// Tabs Default
// Created: 07/2016
// Updated: 18 novembre 2016 / Ajout data-tabs-type pour éviter conflits avec button close dans un autre tab
// Updated: 5 aout 2016 / Ajout tab pour shopping list you might like
// Created for: Recipe detail page

//// Plugin's doc
// required data-:
//		- data-feature : tabs--default // Will be the wrapper DIV of your tabs container
//		- data-is: tab // DIV of your tab
// optional data-:
//		- data-tabs-type : Needed only when a button close(data-tab-close ) is added. Their tabs-type must be identical.
//		- Ex: <div data-feature="tabs--default" data-tabs-type="you-might-like"></div> ... <button data-tabs-type="you-might-like" data-tab-close=".ymlc-coupons"></button>
//		- data-animation-close : CLASS of your animation
//		- data-animation-open : CLASS of your animation
//		- data-display : CLASS OR ID of your target
//		- data-execute : JAVASCRIPT FUNCTION to execute
//		- data-is: tabs // parent DIV of your tabs
//		- data-tabs-follower : true / false // If true, a follower will be added
// 		- data-is : container-tabs // Useful if you want to scope your tabs in a certain part of the dom. Usually above the data-feature="tabs-default"
//							     If data-is="container-tabs" is set to an element, the plugin will look for it  and use it as the container. Useful when you have multiple tab dynamically generated
//		- data-only-breakpoint : mobile-size / tablet-size / desktop-size
//		- data-tab-close : CLASS OR ID of your target
//		- data-toggle : CLASS OR ID of your target // Only use if you want to toggle the tab by clicking on the tab button
// If data-is="container-tabs" is set to an element, the plugin will look for it  and use it as the container. Useful when you have multiple tab dynamically generated


(function($) {

	'use strict';
	$.fn.tabs_default = function() {
		return this.each(function(index) {
			var tabs_wrapper = $(this),
				tabs_wrapper_type = tabs_wrapper.data('tabs-type'),
				tabs_container = ( tabs_wrapper.closest('[data-is="container-tabs"]').length )? tabs_wrapper.closest('[data-is="container-tabs"]') : null,
				only_breakpoint = ( tabs_wrapper.data('only-breakpoint') !== undefined )? tabs_wrapper.data('only-breakpoint') : null,
				tabs = ( tabs_wrapper.find('.tabs, [data-is="tabs"]').length )? tabs_wrapper.find('.tabs, [data-is="tabs"]') : tabs_wrapper,
				tabs_borderWidth = parseInt( tabs.css('border-width') ),
				tab = tabs.find('.tab, [data-is="tab"]'),
				tabs_enabled = false,
				first_load = true,
				was_opened = 0,
				has_follower = tabs_wrapper.data('tabs-follower'),
				btn_close = ( tabs_container === null )? $('[data-tab-close][data-tabs-type="'+ tabs_wrapper_type +'"]') : tabs_container.find('[data-tab-close]');

			// vars for follower
			var tab_current,
				tab_width,
				tab_offsetLeft,
				follower;

			// if data-tabs-follower was set to true then add the follower
			if( has_follower === true ){
				tab_current = tabs.find('.tab.active'),
				tab_width = tab_current.outerWidth(),
				tab_offsetLeft = (tab_current.offset().left - tabs.offset().left) - tabs_borderWidth,
				follower = '<span class="follower" style="left: 0;"></span>';
			}

			// initialize the tabs
			function init(){
				tabs_enabled = true;

				if( has_follower === true ){
					tabs.append( follower );
					follower = tabs.find('.follower');
				}

				tab_active( tabs.find('.tab.active, [data-is="tab"].active') );
			}

			// destroy the tabs
			function destroy() {
				tabs_enabled = false;

				if( has_follower === true ){
					follower.remove();
				}

				tab.each(function(index){
					var target = ( tabs_container !== null )?  $( tabs_container.find( $(this).data('display') ) ) : $( $(this).data('display') );
					target.removeClass('tab--content--inactive tab--content--active');
				});
			}

			// Tab on click action
			btn_close.on('click', function(){

				if( tabs_container !== null ){
					tabs_container.find('[data-display="'+ $(this).data('tab-close') +'"]').removeClass('active');
				}
				tab_active( tabs.find('.tab.active, [data-is="tab"].active') );
			});

			// Called when an action on a tab is required
			function tab_active(tab_current){
				var was_active = false;

				if( tab_current !== undefined && tab_current.hasClass('active') && !first_load ){
					was_active = true;
				}

				if( has_follower === true ){
					tab_width = tab_current.outerWidth(),
					tab_offsetLeft = (tab_current.offset().left - tabs.offset().left) - tabs_borderWidth;

					follower.css({
						left: tab_offsetLeft,
						width: tab_width
					});
				}

				// Remove active class of all tab except on page load
				if( tab_current !== undefined ){
					tab.removeClass('active');
				}

				// Add active class to the active tab
				if( tab_current !== undefined ){
					if( was_active === false ) {
						tab_current.addClass('active');
					}
				}

				// Open / close each tab
				tab.each(function(index){
					var target = ( tabs_container !== null )?  $( tabs_container.find( $(this).data('display') ) ) : $( $(this).data('display') ),
						animation_open = $(this).attr('data-animation-open'),
						animation_close = $(this).attr('data-animation-close'),
						is_active = $(this).hasClass('active'),
						target_is_active = target.hasClass('tab--content--active');

					if( is_active ){

						// If an animation is set, we wait until it's done to continue
						if( $(this).attr('data-animation-open') !== undefined && first_load === false ){

							target.removeClass('tab--content--inactive');
							target.addClass( animation_open );

							target.off('webkitAnimationEnd animationend').on('webkitAnimationEnd animationend', function(){
								target.removeClass(animation_close).addClass('tab--content--active');
							});
						}else {
							target.removeClass('tab--content--inactive').addClass('tab--content--active');
						}


						if( was_opened === 0 ) {
							var execute = eval( $(this).data('execute') );
							if (typeof execute == 'function') {
								execute();
							}
						}
					}else {

						// If an animation is set, we wait until it's done to continue
						if( $(this).attr('data-animation-close') !== undefined && first_load === false && target_is_active ){
							var animation = tab_current.attr('data-animation-close');

							target.removeClass( animation_open ).addClass( animation_close );

							target.off('webkitAnimationEnd animationend').on('webkitAnimationEnd animationend', function(){
								target.removeClass('tab--content--active').addClass('tab--content--inactive');
							});
						}else {
							target.removeClass('tab--content--active').addClass('tab--content--inactive');
						}

					}

				});

				if( first_load === true ){
					first_load = false;
				}
			}

			// Tab on click action
			tab.on('click', function(){

				if( !Revealizr.swiping ){
					tab_active($(this));
				}

			});

			// Destroy or initialize the tabs
			function init_destroy(){

				if( only_breakpoint !== undefined || only_breakpoint !== '' ) {
					if( only_breakpoint !== Revealizr.currentViewportSize && first_load === false && tabs_enabled === true ){
						destroy();
						return;
					}else if( only_breakpoint === Revealizr.currentViewportSize && tabs_enabled === false ) {
						init();
						return;
					}
				}
			}

			init_destroy();

			// If no specific breakpoint is specified, the tabs are initialized and won't never be destroyed
			if( only_breakpoint !== undefined && only_breakpoint !== '' && only_breakpoint !== null ) {
				$(window).on(Revealizr.resizeORorientation, _.throttle( init_destroy, 100 ));
			}else {
				init();
			}


		});
	}
})(jQuery);
